// global
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form } from 'semantic-ui-react';
// local
// consts
import { CYLINDER_STATE } from 'salvus-shared/consts/cylinder';
// api
import * as CylinderApi from 'app/api/cylinder';

class DropdownPatientCylinders extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            options: [],
            patientId: props.patientId,
        };
    }

    componentDidMount() {
        CylinderApi.list()
            .then(this.onLoadCylindersSuccess)
            .catch(this.onLoadCylindersFail);
        this._isMounted = true;
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    onLoadCylindersSuccess = result => {
        let options = [];
        let maxValue = result.filter(c => c.state === CYLINDER_STATE.FULL && c.patientId === this.state.patientId);
        for (let i = 0; i <= maxValue.length; i++) {
            options.push({ key: i, text: i, value: i });
        }
        if (this._isMounted) {
            this.setState({
                loading: false,
                options,
            });
            this.props.onChange(maxValue.length);
        }
    };

    onLoadCylindersFail = () => {
        if (this._isMounted) {
            this.setState({
                loading: false,
                options: [],
            });
        }
    };

    handleChange = (e, target) => {
        const { value } = target || e.target;
        this.props.onChange(value);
    };

    render() {
        const { options, loading } = this.state;
        const { value, style } = this.props;
        return <Form.Dropdown selection loading={loading} options={options} value={value} onChange={this.handleChange} style={style} />;
    }
}

DropdownPatientCylinders.propTypes = {
    value: PropTypes.number,
    onChange: PropTypes.func.isRequired,
    patientId: PropTypes.number,
    style: PropTypes.object,
};

export default DropdownPatientCylinders;
